/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CorrectionRequired
 *
 * 2 = InvoicedAndSubmitted
 *
 * 3 = Pending
 *
 * 4 = WorkNotCompleted
 *
 * 5 = ATPPending
 *
 * 6 = ReadyToWork
 *
 * 7 = Rejected
 */
export enum WarLogStatusesEnum {
  CorrectionRequired = 1,
  InvoicedAndSubmitted = 2,
  Pending = 3,
  WorkNotCompleted = 4,
  ATPPending = 5,
  ReadyToWork = 6,
  Rejected = 7,
}
